import { jsx as t } from "react/jsx-runtime";
import { useFloatingParentNodeId as i, FloatingTree as l, FloatingPortal as p } from "@floating-ui/react";
var c = function c(_ref) {
  var o = _ref.children,
    e = _ref.portalId,
    n = _ref.root;
  var a = i(),
    r = /* @__PURE__ */t(p, {
      id: e,
      root: n,
      children: o
    });
  return a === null ? /* @__PURE__ */t(l, {
    children: r
  }) : r;
};
export { c as default };